const FileSelectionActions = require("../actions/FileSelectionActions.js");

const FileSelectionReducers = {
    [FileSelectionActions.Add](prev, action) {
        const file = action.File;

        let update = (prev.SelectedFiles || []).slice();

        update.push(file);

        return Object.assign({}, prev, {
            SelectedFiles: update
        });
    },
    [FileSelectionActions.Remove](prev, action) {
        const index = prev.SelectedFiles.indexOf(action.File);

        let update = (prev.SelectedFiles || []).slice();

        update.splice(index, 1);

        const hasErrors = update.some((f) => typeof (f.UploadError) !== "undefined");

        return Object.assign({}, prev, {
            SelectedFiles: update,
            Upload: {
                IsWorking: prev.Upload.IsWorking,
                HasErrors: hasErrors
            }
        });
    }
};

module.exports = FileSelectionReducers;


// WEBPACK FOOTER //
// ./src/reducers/FileSelectionReducers.js